import { defineStore } from "pinia";
import { ref } from "vue";

import { asReadonly } from "@/utils/vue";

import { toggled } from "./helpers/toggle";
import { useSelectionStore } from "./selection";

export const usePanModeStore = defineStore("panMode", () => {
  const active = ref(false);

  function toggle(activate?: boolean) {
    if (toggled(active, activate)) {
      if (!useSelectionStore().isSelectingWithRect) {
        useSelectionStore().setSelecting("click");
        active.value = true;
        return true;
      }
      return false;
    }

    useSelectionStore().setSelecting("no");
    active.value = false;
  }

  return {
    active: asReadonly(active),
    toggle,
  };
});
